import { useContext } from "react";
import { UserContext } from "../../../context/CurrentUserProvider";
import TableroEmpresa from "./TableroEmpresa";
import Moment from "moment";
import { useOrders } from "../../../hooks/useOrdersProviders/OrdersContext";

const Tablero = () => {
  const { userDataContext } = useContext(UserContext);

  const { mergedOrders, loadingContext } = useOrders({
    initDateInitial: Moment().format("YYYY-MM-DD"),
    endDateInitial: Moment().format("YYYY-MM-DD"),
  });

  const renderDashboard = (mergedOrders) => {
    switch (userDataContext.roll) {
      case "client":
        return <TableroEmpresa mergedOrders={mergedOrders} />;
      case "company_driver":
        return <TableroEmpresa mergedOrders={mergedOrders} />;
      case "company_ops":
        return <TableroEmpresa mergedOrders={mergedOrders} />;
      case "company_admin":
        return <TableroEmpresa mergedOrders={mergedOrders} />;
      case "bicci_admin":
        return <TableroEmpresa mergedOrders={mergedOrders} />;
      case "biccixpressAdmin":
        return <TableroEmpresa mergedOrders={mergedOrders} />;
      default:
        return <TableroEmpresa />;
    }
  };

  return <div>{renderDashboard(mergedOrders)}</div>;
};

export default Tablero;
